// =============================================================================
// Order status constants — Re-exports from shared state machine (single source of truth)
// =============================================================================

export {
  ORDER_TRANSITIONS as ALLOWED_TRANSITIONS,
  ORDER_STATUS_VARIANT as STATUS_VARIANT,
  ORDER_STATUS_LABELS as STATUS_LABELS,
  ORDER_TRANSITION_LABELS as TRANSITION_LABELS,
  ORDER_PRIMARY_TRANSITION as PRIMARY_TRANSITION,
  ORDER_STATUS_FLOW as STATUS_FLOW_ORDER,
  ORDER_DANGER_STATUSES as DANGER_STATUSES,
  getOrderTransitionLists as getTransitionLists,
} from '@tkpod/shared';

import { ORDER_TRANSITION_LABELS } from '@tkpod/shared';

const DANGER_CONFIRM: Record<string, { label: string; description: string; variant: 'danger' | 'warning' }> = {
  CANCELLED: { label: 'Cancel Order', description: 'This will cancel the order. This action may not be reversible.', variant: 'danger' },
  CANCEL_REQUESTED: { label: 'Request Cancellation', description: 'This will request cancellation. The order is currently in production.', variant: 'danger' },
  ON_HOLD: { label: 'Put on Hold', description: 'This will pause the order. You can release it later.', variant: 'warning' },
  FAILED: { label: 'Mark as Failed', description: 'This will mark the order as failed.', variant: 'danger' },
};

export function getDangerConfirmConfig(action: string): { label: string; description: string; variant: 'danger' | 'warning' } | null {
  return DANGER_CONFIRM[action] ?? null;
}

export { ORDER_TRANSITION_LABELS };
